import React from 'react';
import { getImageThumbnail } from '../../../../../lib/imageUtilsESM';
import { FactoidSpecs } from './FactoidSpecs';
import { Icon } from '../../../components/common/Icon';
import { ImagePreview } from '../../../components/images/ImagePreview';

export function FactoidImage({ factoid }) {
  let imageSpec = factoid.derivedSpecs?.[0]?.[1];
  if (imageSpec) {
    let camera = factoid.derivedSpecs[0][0].split('images.spec.')[1];
    const { uri, width, height, annotations, isRender } = imageSpec;

    const retryImgLoad = function (e) {
      const img = e.target;
      setTimeout(() => img.src += '?refresh=true', 3000);
    };

    return <div className='d-flex mr-2 text-left'>
      {/* <img height={80} className='border border-secondary rounded mr-2' src={getImageThumbnail(uri, 's')}  /> */}
      <ImagePreview zoom={true} className='border border-secondary rounded mr-2' height={80} url={uri} onError={retryImgLoad}/>

      <div>
        <div className='small monospace'>{width || '?'} x {height || '?'}</div>

        <div>
          <span className='badge badge-primary mr-1 monospace align-middle'>{camera}</span>
          
          {isRender ? <Icon icon="3d_rotation" small level={'primary'} title={'isRender=true'}/> : null}
          </div>

        {annotations?.length ? <span>

          {annotations.map(a => a && <span key={a.id}>
            <Icon small icon="crop_free" level={'secondary'} />
            <span className='badge badge-secondary mr-1 monospace align-middle'>{a.id}</span>
          </span>)}
        </span> : null}
      </div>
    </div>;
  } else {
    return <FactoidSpecs factoid={factoid} />;
  }
}
